import { handlePostRequest } from ".";
import { URI } from "../../constants/URI";

export const addLead = async (body) => {
    const res = await handlePostRequest(URI.leads, body);
    return res;
}